import styled from 'styled-components';
import {
  NumberInput as NumberInputComponent,
  TextInput as TextInputComponent,
} from 'src/components/inputs';
import { Checkbox } from '@prisjakt/ui/checkbox/variants';

import { media, layout } from '@prisjakt/ui-base';
import { PrimaryButton, TextButton } from '@prisjakt/ui/button/variants';

interface EmailInputProps {
  error?: boolean;
}

export const EmailInput = styled.div<EmailInputProps>`
  .pj-ui-text-input {
    margin-right: 1rem;
    &--input {
      height: 45px;
    }
  }
  ${media.smallOnly`
    .pj-ui-text-input {
      margin-right: 0;
    }
  `}
  ${p =>
    p.error &&
    `
    .pj-ui-input--input {
      border-color: ${p.theme.colors.negative700};
    }
  `}
`;

interface EmailHintProps extends EmailInputProps {
  visible?: boolean;
  discreetLink?: boolean;
}

export const RatingWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: ${layout.measurements.spacing100};
  align-items: center;
  margin-top: ${layout.measurements.spacing050};

  p {
    margin: 0;
  }
`;

export const EmailHint = styled.div.attrs({ 'data-test': 'EmailHint' })<
  EmailHintProps
>`
  && {
    margin: 0.5rem 0;

    display: ${p => (p.visible ? `block` : 'none')};

    a {
      text-decoration: underline !important;
      ${p => p.discreetLink && `color: ${p.theme.colors.base500};`}
    }

    ${p => p.error && `color: ${p.theme.colors.negative700};`}

    p {
      margin: 0;
    }
  }
`;

export const AlertForm = styled.form`
  ${media.smallOnly`
  .pj-ui-input {
  margin-bottom: 1rem;
  }
  `}
`;

export const PriceBelowWrapper = styled.div`
  display: grid;
  gap: ${layout.measurements.spacing050};
`;

export const NumberInput = styled(NumberInputComponent).attrs({
  variant: 'rounded',
})`
  flex: 1 0 auto;
`;

export const TextInput = styled(TextInputComponent).attrs({
  variant: 'rounded',
})<EmailInputProps>`
  flex: 1 0 auto;
`;

export const PriceStepWrapper = styled.div`
  display: flex;
  margin-top: ${layout.measurements.spacing050};
`;

const INPUT_WIDTH = 77;

export const PriceStepInput = styled.div`
  width: ${INPUT_WIDTH}px;
  margin-left: ${layout.measurements.spacing050};
`;

export const ShopsFilterWrapper = styled.div`
  margin-top: ${layout.measurements.spacing025};
  margin-bottom: ${layout.measurements.spacing100};
`;

export const CheckboxNotify = styled(Checkbox)`
  margin-top: ${layout.measurements.spacing025};
`;

export const RemoveButton = styled(TextButton)`
  margin-bottom: ${layout.measurements.spacing050};
`;

export const SubmitButtonWrapper = styled.div`
  display: flex;
`;

export const CancelButton = styled(TextButton)`
  width: 100%;
  margin-right: ${layout.measurements.spacing050};
`;

export const SaveAlertButton = styled(PrimaryButton)``;
